export default __webpack_public_path__ + "static/media/email.c0385bcb.svg";